import { searchResult } from '@/api'
import localStorage from '@/api/localStorage'
import {
  FETCH_SEARCH_FILTERS,
  SET_ANALYST_STATE,
  SET_TIME_STATE,
  SET_SEARCH_RESULT_LOADING,
  SET_RESEARCH_TYPE,
  LOAD_MORE_RESULT,
  SET_CURRENT_PAGE,
  SET_LOAD_MORE_STATUS,
  SET_CUSTOM_DATE,
  SET_SEARCH_KEY,
  SET_ORDER_BY,
  RESET_SEARCH_FILTER,
  SET_SEARCH_FILTER,
  SET_SEARCH_SYMBOL,
  LOAD_SEARCH_RESULT,
  SET_LOCALSTORAGE_SEARCH_FILTER,
  RESET_TIME_STATE,
  RESET_ORDER_BY_FROM_HOME,
  SET_SYMBOLE,
  SET_ENTITLEMENT_VALUE,
  GET_EXTERNALURL_SEARCH
} from '@/store/actions.type'
import {
  END_LOAD_FETCH_SEARCH_FILTERS,
  SET_ANALYST,
  SET_TIME_SEARCH,
  SET_TIME_SEARCH_FILTER,
  SET_RESEARCH_TYPE_SEARCH_FILTER,
  GET_SEARCH_VALUE,
  SET_SEARCH_LOADING,
  SET_CURRENT_PAGE_VALUE,
  LOAD_MORE_SEARCH_POST,
  SET_LOAD_MOREE_VALUE,
  SET_CUSTOM_DATE_VALUE,
  SET_SEARCH_KEY_VALUE,
  SET_ORDER_BY_VALUE,
  RESET_FILTER_SEARCH,
  SET_FILTER_SEARCH,
  SET_SYMBOL,
  SET_LOCAL_TO_STORE,
  SET_ENTITLEMENT_CHECK,
  SET_EXTERNALURL_SEARCH,
  SET_LOCAL_STORAGE_SEARCH_TAB
} from '@/store/mutations.type'
import { urlParam } from '@/helper'

const state = {
  filters: {},
  searchresult: '',
  searchfilters: {
    key: '',
    symbol: '',
    type: '',
    analyst: '',
    time: '',
    start_time: '',
    end_time: '',
    sort: 'desc',
    is_filter: '',
    category: '',
    search: '',
    ebook: false,
    currentpage: 1
  },
  searchresultloading: false,
  loadmore: false,
  entitlementcheck: true
}
const searchHelper = {
  insertLocalStorage: function ( searchfilter ) {
    localStorage.savelocalStorage( 'searchTab', JSON.stringify( searchfilter ) )
  }
}
const actions = {
  /* Search Result based on Url params */
  [GET_EXTERNALURL_SEARCH]( { commit }, urlParam ) {
    if ( urlParam.tab === 'search' ) {
      commit( SET_EXTERNALURL_SEARCH, urlParam )
    } else {
      urlParam = state.searchfilters
      commit( SET_EXTERNALURL_SEARCH, urlParam )
    }
    commit( SET_SEARCH_LOADING, true )
    return searchResult.getSearchValue( urlParam ).then( ( { data } ) => {
      commit( GET_SEARCH_VALUE, JSON.parse( data ) )
      commit( SET_SEARCH_LOADING, false )
    } )
  },
  [SET_LOCALSTORAGE_SEARCH_FILTER]( { commit }, searchfilter ) {
    commit( SET_LOCAL_TO_STORE, searchfilter )
  },
  async [FETCH_SEARCH_FILTERS]( { commit } ) {
    return searchResult.getfilters().then( ( { data } ) => {
      commit( END_LOAD_FETCH_SEARCH_FILTERS, JSON.parse( data ) )
    } )
  },

  [RESET_ORDER_BY_FROM_HOME]( { commit }, orderby ) {
    commit( RESET_FILTER_SEARCH, orderby )
  },
  [SET_ENTITLEMENT_VALUE]( { commit }, checkvalue ) {
    commit( SET_ENTITLEMENT_CHECK, checkvalue )
  },

  [LOAD_SEARCH_RESULT]( { commit } ) {
    commit( SET_SEARCH_LOADING, true )
    /* After Refreshing page search filter remain same, for this updating state data */
    var searchfilters = JSON.parse( localStorage.getlocalStorage( 'searchTab' ) )
    commit( SET_LOCAL_STORAGE_SEARCH_TAB, searchfilters )
    if ( localStorage.getlocalStorage( 'login' ) === 'on' ) {
      localStorage.destroyLocalStorage( 'login' )
      localStorage.savelocalStorage( 'serachResultload', 'false' )
    } else if ( localStorage.getlocalStorage( 'login' ) == null || localStorage.getlocalStorage( 'reloadStatus' ) === null ) {
      window.onload = function () {
        localStorage.savelocalStorage( 'serachResultload', 'false' )
      }
      if ( localStorage.getlocalStorage( 'serachResultload' ) !== 'true' ) {
        commit( RESET_FILTER_SEARCH, 'desc' )
        commit( SET_LOCAL_TO_STORE, state.searchfilters )
      }
      localStorage.savelocalStorage( 'serachResultload', 'false' )
    }
    return searchResult.getSearchValue( state.searchfilters ).then( ( { data } ) => {
      commit( GET_SEARCH_VALUE, JSON.parse( data ) )
      commit( SET_SEARCH_LOADING, false )
    } )
  },

  [SET_ANALYST_STATE]( { commit }, analystid ) {
    // console.log('analystid', analystid)
    commit( SET_ANALYST, analystid )
    commit( SET_LOCAL_TO_STORE, state.searchfilters )
    return searchResult.getSearchValue( state.searchfilters ).then( ( { data } ) => {
      //	searchHelper.insertLocalStorage(state.searchfilters)
      commit( GET_SEARCH_VALUE, JSON.parse( data ) )
      commit( SET_SEARCH_LOADING, false )
    } )
  },
  [SET_SEARCH_SYMBOL]( { commit }, symbol ) {
    digitalData['searchQuery'] = symbol
    commit( SET_SYMBOL, symbol )
    commit( SET_LOCAL_TO_STORE, state.searchfilters )
    return searchResult.getSearchValue( state.searchfilters ).then( ( { data } ) => {
      // searchHelper.insertLocalStorage(state.searchfilters)
      commit( GET_SEARCH_VALUE, JSON.parse( data ) )
      commit( SET_SEARCH_LOADING, false )
    } )
  },
  [LOAD_MORE_RESULT]( { commit }, analystid ) {
    return searchResult.getSearchValue( state.searchfilters ).then( ( { data } ) => {
      commit( LOAD_MORE_SEARCH_POST, JSON.parse( data ) )
    } )
  },
  [SET_TIME_STATE]( { commit }, timevalue ) {
    commit( SET_TIME_SEARCH_FILTER, timevalue )
    commit( SET_LOCAL_TO_STORE, state.searchfilters )
    return searchResult.getSearchValue( state.searchfilters ).then( ( { data } ) => {
      // searchHelper.insertLocalStorage(state.searchfilters)
      commit( GET_SEARCH_VALUE, JSON.parse( data ) )
      commit( SET_SEARCH_LOADING, false )
    } )
  },
  [RESET_TIME_STATE]( { commit }, timevalue ) {
    commit( SET_TIME_SEARCH_FILTER, timevalue )
  },
  [SET_RESEARCH_TYPE]( { commit }, researchType ) {
    commit( SET_RESEARCH_TYPE_SEARCH_FILTER, researchType )
    // commit(SET_SYMBOL, '')
    commit( SET_LOCAL_TO_STORE, state.searchfilters )
    return searchResult.getSearchValue( state.searchfilters ).then( ( { data } ) => {
      // console.log( JSON.parse( data ).entitlementcheck )
      if ( !JSON.parse( data ).entitlementcheck ) {
        commit( SET_ENTITLEMENT_CHECK, false )
      } else {
        commit( SET_ENTITLEMENT_CHECK, true )
        commit( GET_SEARCH_VALUE, JSON.parse( data ) )
      }

      commit( SET_SEARCH_LOADING, false )
    } )
  },
  [SET_CUSTOM_DATE]( { commit }, startandenddateobj ) {
    commit( SET_CUSTOM_DATE_VALUE, startandenddateobj )
  },
  [SET_SEARCH_KEY]( { commit }, searchkey ) {
    // commit(SET_SYMBOL, '')
    commit( SET_SEARCH_KEY_VALUE, searchkey )
    commit( SET_LOCAL_TO_STORE, state.searchfilters )
    return searchResult.getSearchValue( state.searchfilters ).then( ( { data } ) => {
      //	searchHelper.insertLocalStorage(state.searchfilters)
      commit( GET_SEARCH_VALUE, JSON.parse( data ) )
      commit( SET_SEARCH_LOADING, false )
    } )
  },
  [SET_ORDER_BY]( { commit }, orderby ) {
    commit( SET_ORDER_BY_VALUE, orderby )
    commit( SET_LOCAL_TO_STORE, state.searchfilters )
    return searchResult.getSearchValue( state.searchfilters ).then( ( { data } ) => {
      //	searchHelper.insertLocalStorage(state.searchfilters)
      commit( GET_SEARCH_VALUE, JSON.parse( data ) )
      commit( SET_SEARCH_LOADING, false )
    } )
  },

  [SET_SEARCH_RESULT_LOADING]( { commit }, value ) {
    commit( SET_SEARCH_LOADING, value )
  },
  [SET_CURRENT_PAGE]( { commit }, currentpage ) {
    commit( SET_CURRENT_PAGE_VALUE, currentpage )
  },
  [SET_LOAD_MORE_STATUS]( { commit }, status ) {
    commit( SET_LOAD_MOREE_VALUE, status )
  },
  [RESET_SEARCH_FILTER]( { commit }, status ) {
    commit( RESET_FILTER_SEARCH, status )
  },
  [SET_SEARCH_FILTER]( { commit }, status ) {
    commit( SET_FILTER_SEARCH, status )
  }
}
const mutations = {
  [SET_EXTERNALURL_SEARCH]( state, urlParam ) {
    state.searchfilters = {
      key: urlParam.key,
      symbol: urlParam.symbol,
      type: urlParam.type,
      analyst: urlParam.analyst,
      time: urlParam.time,
      start_time: urlParam.start_time,
      end_time: urlParam.end_time,
      sort: urlParam.sort,
      is_filter: urlParam.is_filter,
      category: urlParam.category,
      search: urlParam.search,
      currentpage: 1
    }
  },
  [SET_LOCAL_TO_STORE]( state, locaksearchfilters ) {
    // console.log('locaksearchfilters', locaksearchfilters)
    state.searchfilters = locaksearchfilters
    searchHelper.insertLocalStorage( state.searchfilters )
  },
  [SET_LOCAL_STORAGE_SEARCH_TAB]( state, locaksearchfilters ) {
    state.searchfilters = locaksearchfilters
  },
  [SET_CUSTOM_DATE_VALUE]( state, coustomdate ) {
    state.searchfilters.start_time = coustomdate.start_time
    state.searchfilters.end_time = coustomdate.end_time
  },
  [END_LOAD_FETCH_SEARCH_FILTERS]( state, searhFilters ) {
    state.filters = searhFilters
  },
  [SET_ENTITLEMENT_CHECK]( state, entitlementcheckvalue ) {
    // console.log( entitlementcheckvalue )
    state.entitlementcheck = entitlementcheckvalue
  },

  [SET_ANALYST]( state, analystid ) {
    state.searchfilters.analyst = analystid
  },
  [SET_SEARCH_KEY_VALUE]( state, searchkey ) {
    state.searchfilters.key = searchkey
    // console.log(state)
  },
  [SET_ORDER_BY_VALUE]( state, orderby ) {
    state.searchfilters.sort = orderby
  },
  [SET_SYMBOL]( state, symbol ) {
    state.searchfilters.symbol = symbol
  },

  [SET_TIME_SEARCH_FILTER]( state, time ) {
    state.searchfilters.time = time
  },
  [SET_RESEARCH_TYPE_SEARCH_FILTER]( state, researchType ) {
    let rtype = researchType.split( '_ebookhistory***' )
    let rtypevalue = ''
    state.searchfilters.ebook = false
    if ( rtype.length > 1 ) {
      state.searchfilters.ebook = true
    }
    state.searchfilters.currentpage = 1
    state.searchfilters.category = rtype[0]
  },
  [GET_SEARCH_VALUE]( state, searchresult ) {
    state.searchresult = searchresult
  },
  [LOAD_MORE_SEARCH_POST]( state, searchresult ) {
    for ( var i = 0; i < searchresult.posts.length; i++ ) {
      state.searchresult.posts.push( searchresult.posts[i] )
    }
    state.loadmore = false
  },
  [SET_SEARCH_LOADING]( state, value ) {
    state.searchresultloading = value
  },
  [SET_CURRENT_PAGE_VALUE]( state, value ) {
    state.searchfilters.currentpage = value
  },
  [SET_LOAD_MOREE_VALUE]( state, value ) {
    state.loadmore = true
  },
  [RESET_FILTER_SEARCH]( state, value ) {
    state.searchfilters = {
      key: '',
      symbol: '',
      type: '',
      analyst: '',
      time: '',
      start_time: '',
      end_time: '',
      sort: 'desc',
      is_filter: '',
      category: '',
      search: '',
      currentpage: 1
    }
  },
  [SET_FILTER_SEARCH]( state, filter ) {
    var filter_name = filter.name
    // console.log(filter_name)
    var filter_value = filter.value
    state.searchfilters.filter_name = { filter_value }
  }
}

const getters = {
  searchResultLoading( state ) {
    return state.searchresultloading
  },
  searchstate( state ) {
    return state
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js